import { useEffect, useState } from "react";
import { getResearchQueryDetail } from "../services/rulesService";

interface IuseFetchResearchQuery {
  setIsLoading: any;
  currentRuleId: any;
  isFromExecution?: boolean;
}
const useFetchResearchQueryByRuleId = ({
  setIsLoading,
  currentRuleId,
  isFromExecution = false,
}: IuseFetchResearchQuery) => {
  const [researchQueryDetail, setResearchQueryDetail] = useState<any>({});
  useEffect(() => {
    setIsLoading(true);
    if (currentRuleId && currentRuleId > 0 && !isFromExecution) {
      const getResearchQueryData = async () => {
        try {
          const result = await getResearchQueryDetail(currentRuleId);
          setResearchQueryDetail(result);
        } catch (err) {
          setResearchQueryDetail({});
        } finally {
          setIsLoading(false);
        }
      };

      getResearchQueryData();
    }
  }, [currentRuleId]);

  return [researchQueryDetail];
};

export default useFetchResearchQueryByRuleId;
